import { useEffect } from 'react';

/**
 * Saves & restores the document title when the owning component is destroyed.
 *
 * @param initial
 * @return a function which can be called to set the title with the ' - dubbie bee' suffix
 */
export default function useTitle(initial?: string) {
    function setTitle(title: string) {
        document.title = title + ' - dubbie bee';
    }

    useEffect(() => {
        const original = document.title;
        if (initial) {
            setTitle(initial);
        }

        return () => {
            document.title = original;
        };
    });

    return setTitle;
}
